import { PlaceService } from '@/types/state/shared';

export function getOnlineFee(services: PlaceService[]) {
  return Math.max(0, ...services.map((s) => s.about?.settings?.onlineFee ?? 0));
}

export function serviceIsExtraTimeAddOn(service: PlaceService) {
  return service?.about?.settings?.isAddOn && service?.about?.settings?.isExtraTime;
}

export function hasExtraTimeAddOn(service: PlaceService) {
  const extraTimeAddOn = ((service?.extra?.addOnServices || []) as PlaceService[]).find(
    (item: PlaceService) => serviceIsExtraTimeAddOn(item),
  );
  return extraTimeAddOn != null;
}

export function servicesWithExtraTimeAddOns(selectedServices: PlaceService[]) {
  const [extraTimeAddonServices, services] = [
    (selectedServices || []).filter((service) => serviceIsExtraTimeAddOn(service)),
    (selectedServices || []).filter((service) => !serviceIsExtraTimeAddOn(service)),
  ];
  const mapServiceWithExtraTimeAddOns: { [key: number]: PlaceService } = {};
  extraTimeAddonServices.forEach((extraTimeService) => {
    for (const s of services) {
      const extraTimeAddOn = (s.extra?.addOnServices || []).find(
        (item: PlaceService) => item.id === extraTimeService.id,
      );
      if (extraTimeAddOn?.id) {
        mapServiceWithExtraTimeAddOns[s.id] = extraTimeAddOn;
        break;
      }
    }
  });
  return {
    services,
    extraTimeAddonServices,
    serviceCount: services.length,
    mapServiceWithExtraTimeAddOns,
  };
}
